$(document).ready(function () {
    $("product-form input").change(function () {
      var selectedCoffeeBean = $("input[name='properties[Coffee Bean]']:checked").val();
      var selectedDrinkType = $("input[name='properties[Drink Type]']:checked").val();
    //   var selectedSize = $("input[name='Size']:checked").val();
    var selectedSize = $("input[data-selector='variant']:checked").val();
        if (selectedSize != null) {
            selectedSize = selectedSize.replace(' ', '');
        }
  
    $(".hidden-sku").each(function () {
        var sku = $(this).data("sku");
        var coffeeBean = $(this).data("coffeeBean");
        var drinkType = $(this).data("drinkType");
        var productVariant = $(this).data("productVariant");
        if (selectedCoffeeBean == coffeeBean && (selectedSize == null || selectedSize == productVariant)) {
            if (selectedCoffeeBean == 'ground-beans'|| selectedCoffeeBean == 'gemalen-bonen') {
                if (selectedDrinkType == drinkType) {
                    $('input[data-properties="SKU"]').val(sku);
                    return false; // Breaks out of the loop
                } else {
                    $('input[data-properties="SKU"]').val('');
                }
            } else {
              
                $('input[data-properties="SKU"]').val(sku);
                return false; // You might also want to break here if needed
            }
        }
    });
    });
  });
  
